type ResetButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

const ResetButton = ({ onClick, disabled }: ResetButtonProps) => (
  <div className="toolbar-right">
    <button
      type="button"
      className="btn-sm btn-outline"
      onClick={onClick}
      disabled={disabled}
    >
      <svg viewBox="0 0 24 24">
        <polyline points="1 4 1 10 7 10" />
        <path d="M3.51 15a9 9 0 101.85-6.86L1 10" />
      </svg>
      Reset
    </button>
  </div>
);

export default ResetButton;
